class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.cartupdate();

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );  

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
        section: "cart-drawer",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  async cartupdate() {
    if(typeof GWP_VARIANT_ID === 'undefined') {
      return;
    }

    fetch(`${routes.cart_url}`, { ...fetchConfig() })
      .then((res) => res.text())
      .then(async (state) => {
        let parsedState = JSON.parse(state);
        const newState = await this.checkAndUpdateGiftProduct(
          parsedState,
        ).catch((error) => {
          console.log(error);
        });
        if (newState && newState.action === "ADDED") {
          this.refreshCart();
        }
        if (newState && newState.action === "REMOVED") {
          this.refreshCart();
        }
      })
      .catch((error) => {
        console.log(error);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  refreshCart() {
    fetch(`${routes.cart_url}`, { ...fetchConfig() })
      .then((res) => res.text())
      .then((state) => {
        let parsedState = JSON.parse(state);
        fetch(
          window.Shopify.routes.root +
            "?sections=" +
            this.getSectionsToRender()
              .map((section) => section.section)
              .join(","),
        )
          .then((res) => res.json())
          .then((res) => {
            parsedState = {
              ...parsedState,
              sections: res,
            };
            this.renderContents(parsedState);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  async checkAndUpdateGiftProduct(parsedState) {
    var totalToCheck = parsedState.items_subtotal_price - 135;
    var availableGwpIndex = -1;

    // Check if the cart contains the gift with purchase (GWP) or the trigger variant
    if (parsedState.items && parsedState.items.length > 0) {
      parsedState.items.forEach((item, index) => {
        if (
          item.id.toString() === GWP_VARIANT_ID &&
          item.properties.is_gwp == true
        ) {
          totalToCheck -= item.final_price;
          availableGwpIndex = index;
        }
      });
    }

    if (totalToCheck >= 5500) {
      if (availableGwpIndex < 0) {
        const state = await this.modifyGiftProduct(GWP_VARIANT_ID, 1);
        return { action: "ADDED", item: state };
      }
    } else {
      if (availableGwpIndex > -1) {
        await this.modifyGiftProduct(GWP_VARIANT_ID, 0);
        return { action: "REMOVED" };
      }
    }
  }

  async modifyGiftProduct(variantId, quantity) {
    const body = JSON.stringify({
      id: variantId,
      quantity: quantity,
      properties: {
        is_gwp: true,
      },
    });

    const url =
      quantity === 0 ? `${routes.cart_change_url}` : `${routes.cart_add_url}`;

    const state = await fetch(url, {
      ...fetchConfig(),
      ...{ body },
    })
      .then((res) => res.json())
      .catch((error) => {
        console.log(error);
      });
    return state;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
